/* ============================================================
   IBRA — FREE SHIPPING PROGRESS BAR
   Listens for cart changes and updates the progress bar.
   Threshold and currency configurable below.
   ============================================================ */
(function () {
  'use strict';

  // ---- CONFIGURATION ----
  const THRESHOLD_EUR = 100; // Free shipping at €100
  const CURRENCY = '€';
  // -----------------------

  function init() {
    injectBars();
    fetchAndUpdate();
    observeCartChanges();
  }

  function injectBars() {
    // Inject into cart page
    const cartPage = document.querySelector('#main-cart-items, .cart, .cart-template, [data-section-type="cart"]');
    if (cartPage && !document.querySelector('.ibra-shipping-bar')) {
      const bar = buildBar();
      cartPage.insertBefore(bar, cartPage.firstChild);
    }

    // Inject into cart drawer
    const drawer = document.querySelector('.drawer, .cart-drawer, #cart-drawer, [id*="cart-drawer"]');
    if (drawer) {
      const drawerInner = drawer.querySelector('.drawer__inner, .cart-drawer__items, .drawer__content') || drawer;
      if (!drawerInner.querySelector('.ibra-shipping-bar')) {
        const bar = buildBar();
        bar.classList.add('ibra-shipping-bar--drawer');
        drawerInner.insertBefore(bar, drawerInner.firstChild);
      }
    }
  }

  function buildBar() {
    const wrap = document.createElement('div');
    wrap.className = 'ibra-shipping-bar';
    wrap.innerHTML =
      '<p class="ibra-shipping-bar__text" data-ibra-shipping-text>' +
        'Add items to your bag to unlock free shipping.' +
      '</p>' +
      '<div class="ibra-shipping-bar__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
        '<div class="ibra-shipping-bar__fill" data-ibra-shipping-fill></div>' +
      '</div>';
    return wrap;
  }

  function fetchAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(updateBars)
      .catch(() => {});
  }

  function updateBars(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    const totalEur = cart.total_price / 100; // Shopify returns cents
    const remaining = Math.max(0, THRESHOLD_EUR - totalEur);
    const percent = Math.min(100, (totalEur / THRESHOLD_EUR) * 100);

    document.querySelectorAll('.ibra-shipping-bar').forEach(bar => {
      const text = bar.querySelector('[data-ibra-shipping-text]');
      const fill = bar.querySelector('[data-ibra-shipping-fill]');
      const progress = bar.querySelector('[role="progressbar"]');

      if (!text || !fill) return;

      if (totalEur === 0) {
        text.innerHTML = 'Add items to your bag to unlock <strong>free shipping</strong>.';
        bar.classList.remove('ibra-shipping-bar--complete');
      } else if (remaining > 0) {
        text.innerHTML = "You're <strong>" + CURRENCY + remaining.toFixed(2) + '</strong> away from free shipping.';
        bar.classList.remove('ibra-shipping-bar--complete');
      } else {
        text.innerHTML = '<strong>✓ Free shipping unlocked.</strong> Enjoy.';
        bar.classList.add('ibra-shipping-bar--complete');
      }

      fill.style.width = percent + '%';
      if (progress) progress.setAttribute('aria-valuenow', String(Math.round(percent)));
    });
  }

  // ---- Listen for cart updates ----
  function observeCartChanges() {
    // 1. Intercept cart-modifying fetch calls
    if (window.fetch) {
      const origFetch = window.fetch;
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const isCartChange = /\/cart\/(add|change|update|clear)/.test(url);
        const promise = origFetch.apply(this, arguments);
        if (isCartChange) {
          promise.then(() => setTimeout(fetchAndUpdate, 150));
        }
        return promise;
      };
    }

    // 2. Shopify's PubSub events (Horizon often uses these)
    document.addEventListener('cart:updated', fetchAndUpdate);
    document.addEventListener('cart:refresh', fetchAndUpdate);

    // 3. Watch for DOM changes that re-inject the cart drawer
    if ('MutationObserver' in window) {
      const obs = new MutationObserver(() => {
        if (!document.querySelector('.ibra-shipping-bar')) {
          injectBars();
          fetchAndUpdate();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
